module.exports = __webpack_public_path__ + "img/home_bnews5_1.b635515d.png";